import { Component, OnInit, Injectable } from '@angular/core';
import { CoreApiService } from '../../core-api.service';
import { DevolucionDTO } from '../../models/DevolucionDTO';
import { LoginDTO } from '../../models/LoginDTO';
import { UsuarioDTO } from '../../models/UsuarioDTO';
import { Router } from '@angular/router';
import { NotifyComponent } from '../notify/notify.component';

import { Global } from '../global/global';

@Component({
	selector: 'app-shared-login',
	template: ''
})
@Injectable()
// tslint:disable-next-line:component-class-suffix
export class Login {
	public devolucionDto: DevolucionDTO;
	public usuarioDto: UsuarioDTO;

	constructor(
		public _coreApi: CoreApiService,
		public _router: Router,
		public _notificador: NotifyComponent,
		public _global: Global
	) {}

	ingresar(loginDto: LoginDTO): Boolean {
		this._coreApi.crear<DevolucionDTO>(loginDto, 'Login/Login').subscribe((res) => {
			if (res.Success == '1') {
				this.usuarioDto = res.Items[0];
				this.usuarioDto.token = res.token;
				this.seteoDatos(this.usuarioDto);
				this._router.navigate([ 'principal' ]);
			} else {
				this._global.mensaje('Login', res.errMsg, 'error');
			}
		});
		return true;
	}

	logout() {
		sessionStorage.removeItem('usuario');
	}

	public seteoDatos(datos) {
		sessionStorage.setItem('usuario', JSON.stringify(datos));
	}
}
